// 教师/后台角色与跨端入口判断：供 Office 登录落地和头像菜单共用。

// 纯教师角色编码；其他角色视为具备后台入口资格。
const TEACHER_ROLE_KEYS = new Set(["teacher", "teacherleader"]);
// 独立后台仅部署在正式业务域名下，避免测试环境误跳生产后台。
const EXTERNAL_ADMIN_ORIGIN = "https://b.szshipian.com";
// 独立后台地址；满足正式域名与环境开关时由用户主动打开。
const EXTERNAL_ADMIN_URL = "https://b.szshipian.com/admin";

/** 将角色编码统一为小写，便于比较 */
function normalizeRoles(roles: string[]): string[] {
  return roles.map((role) => role.toLowerCase());
}

/**
 * 是否含教师端角色（teacher / teacherLeader）
 * @param roles 用户角色编码列表
 */
export function hasTeacherRole(roles: string[]): boolean {
  return normalizeRoles(roles).some((role) => TEACHER_ROLE_KEYS.has(role));
}

/**
 * 是否含后台角色（存在任意非纯教师角色，如 admin、platformAdmin）
 * @param roles 用户角色编码列表
 */
export function hasBackendRoleAccess(roles: string[]): boolean {
  return normalizeRoles(roles).some((role) => !TEACHER_ROLE_KEYS.has(role));
}

/**
 * 返回统一登录首页；所有角色登录后都先进入 Office 工作台。
 * @returns Office 工作台路径
 */
export function resolveDefaultHomePath(): string {
  return "/office/workbench";
}

/** 是否为 Office 教师端路径 */
export function isOfficePath(path: string): boolean {
  return path === "/office" || path.startsWith("/office/");
}

/**
 * 是否启用独立后台入口。
 * @returns 仅正式业务域名且 Vite 环境变量明确为 true 时启用
 */
export function isExternalAdminEnabled(): boolean {
  return (
    window.location.origin === EXTERNAL_ADMIN_ORIGIN &&
    import.meta.env.VITE_USE_EXTERNAL_ADMIN === "true"
  );
}

/**
 * 在新窗口打开独立后台；未启用时由调用方继续使用当前项目后台。
 * @returns 是否已经发起独立后台打开操作
 */
export function openExternalAdminWindow(): boolean {
  if (!isExternalAdminEnabled()) return false;

  // noopener、noreferrer 避免新后台页面反向控制当前 Office 窗口。
  window.open(EXTERNAL_ADMIN_URL, "_blank", "noopener,noreferrer");
  return true;
}
